import { Component, FunctionComponent, ReactElement, useEffect } from "react";
import { FallbackProps } from "react-error-boundary";
import { useNavigate } from "react-router-dom";

function ErrorBoundaryFallback({
  error,
  resetErrorBoundary,
}: FallbackProps): ReactElement<unknown, string | typeof Component | FunctionComponent<{}>> {
  const navigate = useNavigate();

  useEffect(() => {
    console.error(error);
  }, [error]);

  const goHome = () => {
    resetErrorBoundary();
    navigate("/");
  };

  return (
    <div className="row" role="alert" aria-live="assertive">
      <div className="col-md-8 mx-auto mt-5">
        <div className="alert alert-danger" role="alert">
          <h4 className="alert-heading">Oops! Something went wrong.</h4>
          <p>You can try to recover. If the issue persists, refresh the page or try again later.</p>
          <hr />
          <button type="button" className="btn btn-primary" onClick={goHome}>
            Home
          </button>
        </div>
      </div>
    </div>
  );
}

export default ErrorBoundaryFallback;
